import LocationMarkerFilled from './src/location-marker-filled';
export default LocationMarkerFilled;